module.exports = __webpack_public_path__ + "img/logo-cotizacion.aead3d54.png";